import { useEffect } from "react";

const SITE_NAME = "MyFinancesGuru Tools";
const BASE_URL = "https://tools.myfinancesguru.com";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, obj) {
  let el = document.getElementById(id);
  if (!obj) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

// Manages per-page metadata, canonical, OG/Twitter cards and JSON-LD schema.
export default function SEO({ title, description, path = "/", keywords, schema, image, noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title}` : SITE_NAME;
    const url = `${BASE_URL}${path}`;
    document.title = fullTitle;

    setMeta("name", "description", description);
    if (keywords?.length) setMeta("name", "keywords", keywords.join(", "));
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    setLink("canonical", url);

    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", SITE_NAME);
    if (image) setMeta("property", "og:image", image);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);

    setJsonLd("ld-page", schema || null);

    return () => setJsonLd("ld-page", null);
  }, [title, description, path, keywords, schema, image, noindex]);

  return null;
}

export { BASE_URL, SITE_NAME };
